<template>
  <div class="my-content">
    <div class="left-content">
      <Form
        label-position="right"
        :model="dataDetails"
        :label-width="140"
        :rules="ruleFrom"
        ref="dataDetails"
      >
        <Row>
          <Col :span="12">
            <FormItem :label="$t('airport')" prop="target_airport">
              <Select
                v-model="dataDetails.target_airport"
                filterable
                :placeholder="$t('select') + $t('airport')"
              >
                <Option
                  v-for="item in airportList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('warehouseName')" prop="warehouse_id">
              <Select
                v-model="dataDetails.warehouse_id"
                filterable
                :placeholder="$t('select') + $t('warehouseName')"
                @on-change="changeWarehouse"
              >
                <Option
                  v-for="item in warehouseList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.title }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('clearance_agent')" prop="clearance_agent_id">
              <Select
                v-model="dataDetails.clearance_agent_id"
                filterable
                clearable
                :placeholder="$t('select') + $t('clearance_agent')"
              >
                <Option
                  v-for="item in channelList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('HKagency')" prop="hk_agent">
              <Select
                v-model="dataDetails.hk_agent"
                filterable
                :placeholder="$t('select') + $t('HKagency')"
                :filter-by-label="true"
              >
                <Option
                  v-for="item in hkAgentList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('packing_number')" prop="packing_number">
              <i-Input
                v-model="dataDetails.packing_number"
                :placeholder="$t('enter') + $t('packing_number')"
              ></i-Input>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('invoiceWeight')" prop="weight">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.weight"
                :placeholder="$t('enter') + $t('invoiceWeight')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('invoicePCS')" prop="quantity">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.quantity"
                :placeholder="$t('enter') + $t('invoicePCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('skuVolume')" prop="volume">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.volume"
                :placeholder="$t('enter') + $t('skuVolume')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('liquidPCS')" prop="liquid_num">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.liquid_num"
                :placeholder="$t('enter') + $t('liquidPCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('ElectricityPCS')" prop="charged_num">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.charged_num"
                :placeholder="$t('enter') + $t('ElectricityPCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem
              :label="$t('Billing') + $t('invoiceWeight')"
              prop="charging_weight"
            >
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.charging_weight"
                :placeholder="$t('enter') + $t('Billing') + $t('invoiceWeight')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('delivery_method')" prop="lower_port">
              <Select
                v-model="dataDetails.lower_port"
                filterable
                :placeholder="$t('select') + $t('delivery_method')"
                :filter-by-label="true"
              >
                <Option
                  v-for="item in downPortList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem :label="$t('order_desc')" prop="remarks">
              <Input
                v-model="dataDetails.remarks"
                type="textarea"
                :rows="2"
                :placeholder="$t('enter') + $t('order_desc')"
              ></Input>
            </FormItem>
          </Col>

          <Col :span="24">
            <FormItem :label="$t('B2bOrderNo')" prop="airway_number">
              <Input
                v-model="dataDetails.airway_number"
                @on-blur="airwayNumberBlur"
                type="textarea"
                :rows="3"
                :placeholder="$t('enter') + $t('B2bOrderNo')"
              ></Input>
            </FormItem>
          </Col>
        </Row>
				<Col :span="24">
				    <FormItem :label="$t('B2bOrderNo')" prop="ids">
				      <Select
				        v-model="dataDetails.ids"
								:disabled="!airway_numberList.length"
								clearable
								filterable
								multiple
								@on-change="idsChange"
				      >
								<Option
								  v-for="item in airway_numberList"
								  :value="item.value"
								  :key="item.value"
									
									
									:placeholder="$t('select') + $t('delivery_method')"
									:filter-by-label="true"
								  >{{ item.label }}</Option
								>
							</Select>
				    </FormItem>
				  </Col>
				</Row>

        <div class="btn-div">
          <!-- <Button
            type="dashed"
            class="submit-btn"
            size="large"
            @click="SearchSubmit"
            icon="md-search"
            :disabled="dataDetails.package_id.length > 0 ? false : true"
          >
            {{ $t("search") }}
          </Button> -->
          <Button
            type="primary"
            class="submit-btn"
            size="large"
            @click="submitClick"
            icon="md-add"
          >
            {{ $t("order_submit") }}
          </Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import {
  getPackageWarehouse,
  dblpackingAir,
  dblpackingOrder,
  postDblpacking,
  getOrderInfo,
  getDownPort,
	caseNumber,
	airway_number
} from "@/api/packing/packing";
import { getTransportAgent } from "@/api/tracker/air";
export default {
  name: "newB2bPacking",
  data() {
    return {
			airway_numberList:[],
			orderNumber:[],
      dataDetails: {
				ids:[],
        target_airport: "",
        warehouse_id: "",
        clearance_agent_id: "",
        packing_number: "",
        weight: 0,
        quantity: 0,
        volume: 0,
        liquid_num: 0,
        charged_num: 0,
        airway_number: "",
        hk_agent: "",
        charging_weight: 0,
        lower_port: ""
      },
      airportList: [],
      ruleFrom: {
        target_airport: [
          {
            required: true,
            message: this.$t("select") + this.$t("airport"),
            trigger: "change"
          }
        ],
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("warehouseName"),
            trigger: "change"
          }
        ],
        // clearance_agent_id: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: this.$t("select") + this.$t("clearance_agent"),
        //     trigger: "change"
        //   }
        // ],
        packing_number: [
          {
            required: true,
            message: this.$t("enter") + this.$t("packing_number"),
            trigger: "blur"
          }
        ],
        charged_num: [
          {
            required: true,
            type: "number",
            message: this.$t("enter") + this.$t("ElectricityPCS"),
            trigger: "blur"
          }
        ],
        airway_number: [
          {
            required: true,
            message: this.$t("enter") + this.$t("B2bOrderNo"),
            trigger: "blur"
          }
        ],
				ids: [
				  {
				    required: true,
				    message: this.$t("select") + this.$t("B2bOrderNo"),
				    trigger: "blur",
						type:'array'
				  }
				],
      },
      warehouseList: [],
      channelList: [],
      loading: false,
      orderList: [],
      oldAirway_number: "",
      hkAgentList: [],
      downPortList: []
    };
  },
  mounted() {
    this.getotherList();
  },
  methods: {
		idsChange(ids){
			this.dataDetails.quantity = ids.reduce((a,b)=>{
				let item = this.airway_numberList.find(t=>b===t.value)
				a+= item.quantity
				return a
			},0)
		},
    // b2b订单失去焦点
    airwayNumberBlur() {
      if(this.dataDetails.airway_number && this.dataDetails.warehouse_id)airway_number({
				airway_number:this.dataDetails.airway_number,
				warehouse_id:this.dataDetails.warehouse_id
			}).then(res=>{
				if(res.data.status){
					this.dataDetails.ids = []
					this.airway_numberList = res.data.payload
				}
			})
    },
    getotherList() {
      getPackageWarehouse().then(res => {
        this.warehouseList = res.data.payload;
      });
      dblpackingAir().then(res => {
        this.airportList = res.data.payload;
      });
      getTransportAgent().then(res => {
        this.channelList = res.data.payload;
      });
      getTransportAgent({ type: 4 }).then(res => {
        this.hkAgentList = res.data.payload;
      });
      getDownPort().then(res => {
        this.downPortList = res.data.payload;
      });
    },
    submitClick() {
      this.$refs["dataDetails"].validate(valid => {
        if (valid) {
          let data = this.dataDetails;
          data["method"] = "post";
          postDblpacking(data).then(res => {
            if (res.data.code == 0) {
              this.$refs["dataDetails"].resetFields();
              this.$Message["success"]({
                background: true,
                content: res.data.msg
              });
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg
              });
            }
          });
        }
      });
    },
    changeWarehouse(val) {
			this.airwayNumberBlur()
      // if (val) {
      //   let data = {
      //     warehouse_id: val
      //   };
      //   dblpackingOrder(data).then(res => {
      //     this.orderList = res.data.payload;
      //   });
      // } else {
      //   this.orderList = [];
      // }
      // this.dataDetails.airway_number = [];
    }
  }
};
</script>

<style scoped lang="less">
.my-content {
  height: 100%;
  display: flex;
  background: #fff;
}
.left-content {
  width: 70%;
  margin: 0 auto;
  height: 100%;
  background: #fff;
  padding: 10px;
}
.right-content {
  width: 470px;
  height: 100%;
  margin-left: 30px;
  background: #fff;
  padding: 10px;
}
.submit-btn {
  width: 150px;
  margin: 0 20px;
}
.btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
}
.search-div {
  display: flex;
  margin-bottom: 24px;
}
.search-div button {
  margin-left: 20px;
}
.bag-code {
  border: 1px solid #dcdee2;
  height: 400px;
  border-radius: 4px;
}
.check-all {
  position: absolute;
  width: 100%;
  top: 0;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 15px;
}
.check-client {
  position: absolute;
  top: 40px;
  width: 100%;
  height: 400px;
  overflow: auto;
  padding: 0 10px;
}
</style>
